import { checkAndCacheAll } from './common'

export async function getSpyders (fetchFunction) {
  // return checkAndCacheAll('spyders', fetchFunction)
  return checkAndCacheAll('spyders', fetchFunction)
}

export async function getSpyderAnalytics (fetchFunction) {
  // return checkAndCacheAll('spyderAnalytics', fetchFunction)
  return checkAndCacheAll('spyderAnalytics', fetchFunction)
}
